import { defineComponent as _defineComponent } from 'vue'
import Header from "@/components/sgre/Header.vue";
import Footer from "@/components/sgre/Footer.vue";
import { useRouter } from "vue-router";
import { onMounted, ref } from "vue";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();

const notFoundVinNo = ref("");

onMounted(function () {
  clearVinNo();
  notFoundVinNo.value = store.getters.notFoundVinNo;
});

const toSearchGrade = () => {
  router.push("/SearchGrade");
};

const clearVinNo = () => {
  notFoundVinNo.value = "";
};

const openPDF = () => {
  window.open("contact_paper.pdf");
};

const __returned__ = { router, notFoundVinNo, toSearchGrade, clearVinNo, openPDF, Header, Footer }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})